module.exports = __webpack_public_path__ + "img/barcode.4721b0e5.svg";